import {
    ApplicationConfig,
    importProvidersFrom,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import {provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {AppModule} from './app.module';
//import {provideClientHydration, withEventReplay, withNoHttpTransferCache} from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
    providers: [
     //   provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({eventCoalescing: true}),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        importProvidersFrom(AppModule),
    ],
};
